import { inject, provideAppInitializer } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faBars,
  faBracketsCurly,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircle6,
  faCircle7,
  faCircle8,
  faCircle9,
  faCircleCheck,
  faCircleExclamation,
  faCircleQuestion as fasCircleQuestion,
  faCoins,
  faEnvelope,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFileSignature as fasFileSignature,
  faFingerprint,
  faGlobe,
  faInfoCircle,
  faKey,
  faLanguage,
  faMousePointer,
  faObjectsColumn,
  faPenField as fasPenField,
  faPenToSquare,
  faPhone,
  faPlus,
  faRightFromBracket,
  faSack,
  faSave,
  faShieldCheck,
  faTimes,
  faTrash as fasTrash,
  faUserDoctor,
  faUserDoctorHair,
  faUserDoctorHairLong,
  faUserHair,
  faUserHairLong,
  faUserHairMullet,
  faWheelchair,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faCalendar,
  faCalendarAlt,
  faCircleExclamation as farCircleExclamation,
  faCircleQuestion,
  faCoins as farCoins,
  faDownload,
  faFileSignature,
  faHandHoldingDollar,
  faObjectsColumn as farObjectsColumn,
  faPaperclip,
  faPen,
  faPenField,
  faPercent,
  faRightFromBracket as farRightFromBracket,
  faRotateLeft,
  faSack as farSack,
  faScaleBalanced,
  faSearch,
  faShieldCheck as farShieldCheck,
  faSpinner,
  faTombstone,
  faTrash as farTrash,
  faUpload,
  faUser,
} from '@fortawesome/pro-regular-svg-icons';

function initializeFontAwesomeFactory(faIconLibrary: FaIconLibrary) {
  return () =>
    new Promise<any>((resolve: any) => {
      // Add only the specific icons used in the application
      const fasIcons = [
        faAngleDown,
        faAngleLeft,
        faAngleRight,
        faBars,
        faBracketsCurly,
        faCaretDown,
        faCaretUp,
        faCheck,
        faChevronDown,
        faChevronUp,
        faCircle,
        faCircle1,
        faCircle2,
        faCircle3,
        faCircle4,
        faCircle5,
        faCircle6,
        faCircle7,
        faCircle8,
        faCircle9,
        faCircleCheck,
        faCircleExclamation,
        fasCircleQuestion,
        faCoins,
        faEnvelope,
        faExclamationTriangle,
        faExternalLinkAlt,
        fasFileSignature,
        faFingerprint,
        faGlobe,
        faInfoCircle,
        faKey,
        faLanguage,
        faMousePointer,
        faObjectsColumn,
        fasPenField,
        faPenToSquare,
        faPhone,
        faPlus,
        faRightFromBracket,
        faSack,
        faSave,
        faShieldCheck,
        faTimes,
        fasTrash,
        faWheelchair,
        faXmark,
        faUserDoctorHair,
        faUserDoctor,
        faUserDoctorHairLong,
        faUserHair,
        faUserHairLong,
        faUserHairMullet,
      ];

      const farIcons = [
        faArrowLeft,
        faArrowRight,
        faCalendar,
        faCalendarAlt,
        farCircleExclamation,
        faCircleQuestion,
        farCoins,
        faDownload,
        faFileSignature,
        faHandHoldingDollar,
        farObjectsColumn,
        faPaperclip,
        faPen,
        faPenField,
        faPercent,
        farRightFromBracket,
        farSack,
        faScaleBalanced,
        faSearch,
        farShieldCheck,
        faSpinner,
        faTombstone,
        farTrash,
        faUpload,
        faUser,
        faRotateLeft,
      ];

      faIconLibrary.addIcons(...fasIcons, ...farIcons);
      resolve();
    });
}

export const AppInitializerFontAwesome = provideAppInitializer(() => {
  const initializerFn = initializeFontAwesomeFactory(inject(FaIconLibrary));
  return initializerFn();
});
